import React, { useMemo } from 'react';

import { IBasicStyledProps } from '@notino/react-styleguide-v20';

import { useLocalizationContext, useRouteLocalization } from '@services/localizationService';
import { usePageLoadMessaging } from '@services/messagingService';
import { Header } from '@sharedComponents/Header';
import { EPage, ReactFCC } from '@types';

import { ICheckoutPageLayoutMessages } from '../../../model';
import { getFormattedMessages } from '../../../utils';

interface IOrderPageLayoutProps extends IBasicStyledProps {
  page: EPage;
  homePageUrlAddress: string;
  messages: ICheckoutPageLayoutMessages;
  skeletonComponent: React.FunctionComponent;

  isCallCenterOpened: boolean;
  callCenterPhoneNumber: string;
  callCenterOpeningHours: string;
}

export const OrderPageLayout: ReactFCC<IOrderPageLayoutProps> = ({
  page,
  homePageUrlAddress,
  messages,
  isCallCenterOpened,
  callCenterPhoneNumber,
  callCenterOpeningHours,
  skeletonComponent,
  children,
}) => {
  const { translationsReady } = useLocalizationContext();
  useRouteLocalization(page);
  usePageLoadMessaging();

  const { callCenterNumberMessage, callCenterOpeningHoursMessage } = useMemo(
    () => getFormattedMessages(messages, callCenterPhoneNumber, callCenterOpeningHours, isCallCenterOpened),
    [messages, callCenterPhoneNumber, callCenterOpeningHours, isCallCenterOpened],
  );

  const SkeletonComponent = skeletonComponent;

  if (!translationsReady) {
    return (
      <>
        <Header />
        <SkeletonComponent />;
      </>
    );
  }

  return (
    <div>
      <Header
        linkUrlAddress={homePageUrlAddress}
        callCenterText={callCenterNumberMessage}
        callCenterOpeningHours={callCenterOpeningHoursMessage}
      />
      {children}
    </div>
  );
};
